// import breakpoints from '../../assets/stylesheets/breakpoints.css'
import env from './env';

const breakpoints = {
  phone: 320,
  landscape: 576,
  tablet: 768,
  desktop: 992,
  max: 1200,
};

export const isBelowPhone = () => !env.isNode() && window.innerWidth <= breakpoints.phone;
export const isBelowLandscape = () => !env.isNode() && window.innerWidth <= breakpoints.landscape;
export const isBelowTablet = () => !env.isNode() && window.innerWidth <= breakpoints.tablet;
export const isBelowDesktop = () => !env.isNode() && window.innerWidth <= breakpoints.desktop;
export const isBelowMax = () => !env.isNode() && window.innerWidth <= breakpoints.max;


export const isAboveLandscape = (breakpoint) => {
  if (breakpoint) {
    return breakpoint !== 'phone' && breakpoint !== 'landscape';
  }
  return !env.isNode() && window.innerWidth > breakpoints.landscape;
};
export const isAbovePhone = () => !env.isNode() && window.innerWidth > breakpoints.phone;
export const isAboveTablet = () => !env.isNode() && window.innerWidth > breakpoints.tablet;
export const isAboveDesktop = () => !env.isNode() && window.innerWidth > breakpoints.desktop;
export const isAboveMax = () => !env.isNode() && window.innerWidth > breakpoints.max;
